export class GcpVpcPeering {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "peerProjectId",
            "baseName": "peerProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "peerNetwork",
            "baseName": "peerNetwork",
            "type": "string",
            "format": ""
        },
        {
            "name": "cidrs",
            "baseName": "cidrs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "VpcPeeringStatus",
            "format": ""
        },
        {
            "name": "peeringName",
            "baseName": "peeringName",
            "type": "string",
            "format": ""
        },
        {
            "name": "createError",
            "baseName": "createError",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GcpVpcPeering.attributeTypeMap;
    }
    constructor() {
    }
}
